module.exports = "https://static.wmbcdn.com/uniweb/images/04ee933f58083803aa5b2be741ecf517.svg";